import "../css/PostDetail.css";
import { useState } from "react";
import { Flex, Row, Col } from 'antd';
import { useQuery } from "@apollo/client";
import dayjs from 'dayjs';
import 'dayjs/locale/es';
import { getFromLocalStorage, saveToLocalStorage } from "../utils/localStorage";
import { GET_POST_DETAIL } from "../queries";
import setImageAbsoluteUrl from "../utils/setImageAbosulteUrl"

const PostDetailComp = ({ slug, categoryName, lang }) => {
  
  dayjs.locale(lang);

  const [sectionData, setSectionData] = useState(() => {
    const cachedData = getFromLocalStorage(slug);
    return cachedData?.posts?.[slug] || null;
  });

  const { loading, error, data } = useQuery(GET_POST_DETAIL, {
    variables: { slug },
    skip: !!sectionData,
    onCompleted: (fetchedData) => {
      const postData = fetchedData?.postBy;
      const dataToLocal = {
        ...sectionData,
        posts: {
          [slug]: postData,
        },
      };
      saveToLocalStorage(slug, dataToLocal);
      setSectionData(postData);
    },
  });
  
  const note = `Nota de ${categoryName}`
  const formattedDate = dayjs(sectionData?.date).format('DD [de] MMMM [de] YYYY');
  return (
    <Flex className="PostContainer">
      <div className="PostContent">
        <Row>
          <Col span={24}>
            <p className="bt-small-500">{formattedDate}</p>
            <h1 className="s1-subtitle-600">{sectionData?.title}</h1>
          </Col>
        </Row>
        {sectionData?.featuredImage?.node?.mediaItemUrl && (
          <Row>
            <Col span={24}>
              <img
                loading="lazy"
                src={setImageAbsoluteUrl(sectionData?.featuredImage?.node?.mediaItemUrl)}
                alt={sectionData?.featuredImage?.node?.title}
              />
            </Col>
          </Row>
      )}
        <Row>
          <Col span={24}>
            <div
              className="b3-body-400"
              dangerouslySetInnerHTML={{ __html: sectionData?.content }}
            />
          </Col>
        </Row>
      </div>
    </Flex>
  );
};

export default PostDetailComp;
